import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/ReceiveWax.css";

export default function CompletedWax() {
  const [lots, setLots] = useState([]);
  const [castingDate, setCastingDate] = useState({}); // store date per item

  useEffect(() => {
    fetchCompletedLots();
  }, []);

  // ============================================================
  // FETCH COMPLETED LOTS (ONLY ITEMS NOT MOVED TO CASTING)
  // ============================================================
  const fetchCompletedLots = async () => {
    const { data: lotsData } = await supabase
      .from("WAX_LOTS")
      .select("id, lot_no, worker_id, issue_date, status")
      .eq("status", "COMPLETED")
      .order("issue_date", { ascending: false });

    if (!lotsData || lotsData.length === 0) {
      setLots([]);
      return;
    }

    const lotIds = lotsData.map((l) => l.id);

    // fetch items
    const { data: items } = await supabase
      .from("WAX_ITEMS")
      .select(`
        id,
        lot_id,
        item_id,
        design_code,
        issued_net,
        received_net,
        ITEMS(item_name)
      `)
      .in("lot_id", lotIds);

    // fetch casting_done (hide items already moved)
    const { data: moved } = await supabase
      .from("casting_done")
      .select("wax_item_id");

    const movedIds = moved?.map((m) => m.wax_item_id) || [];

    const filteredItems = items.filter((i) => !movedIds.includes(i.id));

    const merged = lotsData.map((lot) => ({
      ...lot,
      items: filteredItems.filter((i) => i.lot_id === lot.id),
    }));

    setLots(merged);
  };

  // ============================================================
  // SAVE CASTING DONE
  // ============================================================
  const saveCastingDone = async (lot, item) => {
    const dateValue = castingDate[item.id];

    if (!dateValue) {
      alert("Please select a date.");
      return;
    }

    const gainLoss =
      Number(item.received_net || 0) -
      Number(item.issued_net || 0);

    const { error } = await supabase.from("casting_done").insert({
      lot_id: lot.id,
      lot_no: lot.lot_no,
      item_id: item.item_id,
      wax_item_id: item.id,
      gain_loss: gainLoss,
      casting_date: dateValue,
    });

    if (error) {
      alert("Error saving casting entry");
      console.error(error);
      return;
    }

    alert("Moved to Casting!");

    // refresh to hide moved item
    fetchCompletedLots();
  };

  // ============================================================
  // UI
  // ============================================================
  return (
    <div className="receive-container">
      <h2 className="page-title">Completed Wax Lots</h2>

      {lots.length === 0 && <p>No completed lots.</p>}

      {lots
  .filter((lot) => lot.items.length > 0)  // <--- NEW LINE
  .map((lot) => {

        const totalGainLoss = lot.items.reduce((sum, it) => {
          return (
            sum +
            (Number(it.received_net || 0) -
              Number(it.issued_net || 0))
          );
        }, 0);

        return (
          <div className="lot-card" key={lot.id}>
            <div className="lot-header">
              <h3>{lot.lot_no}</h3>
              <p>Date: {lot.issue_date?.slice(0, 10)}</p>
              <p>
                <b>Total Gain/Loss: </b>
                <span
                  style={{
                    color: totalGainLoss >= 0 ? "green" : "red",
                    fontWeight: "bold",
                  }}
                >
                  {totalGainLoss.toFixed(3)}
                </span>
              </p>
            </div>

            {/* ================= FIXED TABLE WIDTH ================= */}
            <table
              className="wax-table"
              style={{
                tableLayout: "fixed",
                width: "100%",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "18%" }}>Item</th>
                  <th style={{ width: "12%" }}>Design</th>
                  <th style={{ width: "10%" }}>Issued Net</th>
                  <th style={{ width: "12%" }}>Received Net</th>
                  <th style={{ width: "10%" }}>Gain/Loss</th>
                  <th style={{ width: "18%" }}>Date</th>
                  <th style={{ width: "12%" }}>Action</th>
                </tr>
              </thead>

<tbody>
  {lot.items.length === 0 ? (
    <tr>
      <td colSpan="7" style={{ textAlign: "center" }}>
        All items moved to casting
      </td>
    </tr>
  ) : (
    lot.items.map((it) => {
      const issued = Number(it.issued_net || 0);
      const received = Number(it.received_net || 0);
      const gainLoss = received - issued;

      return (
        <tr key={it.id}>
          {/* WRAP TEXT INSIDE CELLS */}
          <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {it.ITEMS?.item_name}
          </td>

          <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {it.design_code}
          </td>

          <td>{issued}</td>
          <td>{received}</td>

          <td
            style={{
              fontWeight: "bold",
              color: gainLoss >= 0 ? "green" : "red",
            }}
          >
            {gainLoss.toFixed(3)}
          </td>

          {/* DATE + BUTTON IN ONE FLEX BOX SO THEY NEVER OVERFLOW */}
          <td colSpan={2}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                justifyContent: "flex-end",
                flexWrap: "wrap",
              }}
            >
              <input
                type="date"
                style={{
                  padding: "5px",
                  fontSize: "14px",
                  width: "130px",
                }}
                value={castingDate[it.id] || ""}
                onChange={(e) =>
                  setCastingDate((prev) => ({
                    ...prev,
                    [it.id]: e.target.value,
                  }))
                }
              />

              <button
                className="wax-btn"
                style={{
                  padding: "6px 10px",
                  whiteSpace: "nowrap",
                }}
                onClick={() => saveCastingDone(lot, it)}
              >
                Move to Casting
              </button>
            </div>
          </td>
        </tr>
      );
    })
  )}
</tbody>

            </table>
          </div>
        );
      })}
    </div>
  );
}
